var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.edit)?_c('gridView',{on:{"editItem":_vm.editItem}}):_c('formView',{attrs:{"identifier":_vm.identifier},on:{"editItem":_vm.editItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }